import React, { useState } from "react"
import { getConversionResult } from "../utils/utils"
import Input from "./input"
import MySelect from "./myselect"

import "./form.css"

const ToolForm = ({ text, utils }) => {
  const [ingredient, setIngredient] = useState("")
  const [measure1, setMeasure1] = useState("")
  const [measure2, setMeasure2] = useState("")
  const [value1, setValue1] = useState("")
  const [value2, setValue2] = useState("")

  function handleSelectChange(input, value) {
    setValue1("")
    setValue2("")
    if (input === "1") {
      setIngredient(value)
    } else if (input === "2") {
      setMeasure1(value)
    } else {
      setMeasure2(value)
    }
  }
  function handleInputChange(input, value) {
    if (input === "1") {
      setValue1(value)
      let output = getConversionResult(
        ingredient.group,
        measure1.value,
        measure2.value,
        value
      )
      if (output <= 0) {
        output = ""
      }
      setValue2(output)
    } else {
      setValue2(value)
      let output = getConversionResult(
        ingredient.group,
        measure2.value,
        measure1.value,
        value
      )
      if (output <= 0) {
        output = ""
      }
      setValue1(output)
    }
  }
  return (
    <div id="tool-form">
      <form>
        <fieldset>
          <div className="form-rows">
            <MySelect
              name="format"
              label={text.ingredient}
              placeholder={text.selectPlaceholder}
              options={utils.ingredients}
              value={ingredient}
              handleChange={selectedOption =>
                handleSelectChange("1", selectedOption)
              }
            />
          </div>
          <div className="form-rows">
            <MySelect
              name="format"
              label={text.measure1}
              placeholder={text.selectPlaceholder}
              options={
                ingredient
                  ? ingredient.type === "solid"
                    ? utils.solidMeasures
                    : utils.liquidMeasures
                  : []
              }
              value={measure1}
              handleChange={selectedOption =>
                handleSelectChange("2", selectedOption)
              }
            />
            <MySelect
              name="format"
              label={text.measure2}
              placeholder={text.selectPlaceholder}
              options={
                ingredient
                  ? ingredient.type === "solid"
                    ? utils.solidMeasures
                    : utils.liquidMeasures
                  : []
              }
              value={measure2}
              handleChange={selectedOption =>
                handleSelectChange("3", selectedOption)
              }
            />
          </div>
          {ingredient && measure1 && measure2 && (
            <div className="form-rows">
              <Input
                name="qtd1"
                type="number"
                label={text.qtd}
                value={value1}
                onChange={e => handleInputChange("1", e.target.value)}
              />
              <Input
                name="qtd2"
                type="number"
                label={text.qtd}
                value={value2}
                onChange={e => handleInputChange("2", e.target.value)}
              />
            </div>
          )}
        </fieldset>
      </form>
    </div>
  )
}

export default ToolForm
